module.exports = __webpack_public_path__ + "static/media/no_content.47615164.svg";